const ArrowUp = 'ArrowUp'
const ArrowDown = 'ArrowDown'
export const KEYBOARD_KEYS = {
  ArrowUp,
  ArrowDown,
}
